import React, { useState } from 'react';
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import { useProductStore } from 'src/hooks/product';
import Helper from 'src/helper/Helper';
import { __remove, __set } from 'src/store/axios_indicator';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const SendEmailOfReportError = (props) => {
    const { SetStatus, data } = props;
    const [formData, setFormData] = useState({ typeofError: [], information: '', name: '', email: '' })
    const [errors, setErrors] = useState({})
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { send_Report_Error_Email }, { }] = useProductStore();
    const emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const partNo = data?.productDetail?.ERPMFRPartNumber ? data?.productDetail.ERPMFRPartNumber : '-'
    const manufacturerName = data?.productDetail?.ManufacturerName ? data?.productDetail.ManufacturerName : '-'
    const productDescription = data?.productDetail?.ShortDescription ? data?.productDetail.ShortDescription : '-'
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    const handleOnChange = (name, value, key) => {
        if (Object.keys(errors)?.length > 0) {
            delete errors[name]
        }
        if (name === 'typeofError') {
            setFormData({ ...formData, 'typeofError': value ? [...formData.typeofError, key] : formData.typeofError.filter(ele => ele !== key) })
        } else {
            setFormData({ ...formData, [name]: value })
        }
    }

    const onValidateData = () => {
        let validationModal = {}
        Helper.valueIsNotNull(formData.typeofError) ? "" : validationModal.typeofError = "Error type should be selected.";
        Helper.valueIsNotNull(formData.information) ? (formData.information?.length > 999 ? validationModal.information = "Please enter a valid Additional Information, Max character exceeded" : '') : '';
        Helper.valueIsNotNull(formData.name) ? "" : validationModal.name = "Please enter a valid Name";
        !Helper.valueIsNotNull(formData.email) || !Helper.validateRegex(formData.email, emailPattern) ? validationModal.email = "Please enter a valid Email" : '';
        setErrors({ ...validationModal })
        return Object.keys(validationModal).length > 0 ? false : true;
    }

    const onSubmit = async () => {
        const valid = onValidateData()
        if (valid) {
            const reqBody = {
                "partNo": partNo,
                "manufacturerName": manufacturerName,
                "productDescription": productDescription,
                "typeofError": formData.typeofError,
                "additionalInformation": formData.information,
                "name": formData.name,
                "email": formData.email
            }
            __set('SEND_REPORT_ERROR_EMAIL_API_CALL')
            const res = await send_Report_Error_Email(reqBody);
            __remove('SEND_REPORT_ERROR_EMAIL_API_CALL')
            if (res.isSuccessFull) {
                system_alert_indicator({
                    name: 'productDetailsErr',
                    message: 'Thank you! Your report has been submitted. An Avnet representative will look into the situation.',
                    type: "success"
                })
                
            } else {
                system_alert_indicator({
                    name: 'productDetailsErr',
                    message: res.message || 'Something went wrong',
                    type: "danger"
                })
                
            }
            SetStatus(false)
        }
    }

    const TypeOfError = [
        { key: 'Product Description / Attribute' },
        { key: 'Image / Schematic' },
        { key: 'Datasheet' },
        { key: 'Search / Navigation' },
        { key: 'Alternative / Substitutes Products' },
        { key: 'Pricing' },
        { key: 'Other' }
    ]

    return (
        <div className="avnet-modal modal-630" id="sendMailModal">
            <div className="avnet-modal-inner">
                <button type="button" className="close" data-dismiss="modal"
                    onClick={() => SetStatus(false)}> ×
                </button>
                <div className="modal-header justify-content-center">
                    <h2 className="pcn-modal-heading">Report Error</h2>
                </div>
                <div className="modal-body">
                    <form id="hook-form">
                        <p className="mb-1 font-14">Thank you for assisting the Avnet.com team in improving our
                            website and product data.Your feedback on any errors is much appreciated</p>
                        <div className="label-value mb-3">
                            <div className="label-value-item">
                                <label>Part No.</label>
                                <span>{partNo}</span>
                            </div>
                            <div className="label-value-item">
                                <label>Manufacturer Name:</label>
                                <span>{manufacturerName}</span>
                            </div>
                            <div className="label-value-item">
                                <label>Product Description:</label>
                                <span>{productDescription}</span>
                            </div>
                        </div>
                        <div className="row m-0">
                            <div className="col-12">
                                <div className="form-group">
                                    <label htmlFor="email"><b>Type of Error (select all that apply)</b> <span
                                        className="mandatory">*</span></label>
                                    {TypeOfError.map((obj, idx) => (
                                        <div className="form-check" key={idx}>
                                            <input type="checkbox" className="form-check-input" id="customCheck1"
                                                name="typeofError" value={obj.key}
                                                onChange={({ target: { checked } }) => handleOnChange('typeofError', checked, obj.key)}
                                            />
                                            <label className="form-check-label" htmlFor="customCheck1">{obj.key}</label>
                                        </div>
                                    ))}
                                    <p className="error">{errors?.typeofError}</p>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label htmlFor="Information">Additional Information (optional)</label>
                                        <textarea name="information" rows={8} cols={60}
                                            className="avnet-textBox form-control h-auto"
                                            placeholder="Comments" id="Comments"
                                            onChange={({ target: { value } }) => handleOnChange('information', value)}
                                        />
                                        <p className="error">{errors?.information}</p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="name">Name <span className="mandatory">*</span></label>
                                    <input type="text" name="name" aria-label="Share via Name" id="name"
                                        size={60} className="avnet-textBox form-control" placeholder="Name"
                                        onChange={({ target: { value } }) => handleOnChange('name', value)}
                                    />
                                    <p className="error">{errors?.name}</p>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email">Email <span className="mandatory">*</span></label>
                                    <input type="text" name="email" aria-label="Share via email" id="email"
                                        size={60} className="avnet-textBox form-control h-auto"
                                        placeholder="Email"
                                        onChange={({ target: { value } }) => handleOnChange('email', value)}
                                    />
                                    <p className="error">{errors?.email}</p>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                {__check(['SEND_REPORT_ERROR_EMAIL_API_CALL']).render}
                {!__check(['SEND_REPORT_ERROR_EMAIL_API_CALL']).status &&
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary minw-auto" data-bs-toggle="modal"
                                data-bs-target="#ReportModal"
                                onClick={() => SetStatus(false)}> Cancel
                            </button>
                            <button type="button" className="bs5 btn btn-primary minw-auto" data-bs-toggle="modal"
                                data-bs-target="#ReportModal" form="hook-form" onClick={() => onSubmit()}>
                                Submit
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default SendEmailOfReportError;